"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stage = void 0;
// Application environment constants
var Stage;
(function (Stage) {
    Stage["Local"] = "local";
    Stage["Dev"] = "dev";
    Stage["Beta"] = "beta";
    Stage["Gamma"] = "gamma";
    Stage["Prod"] = "prod";
})(Stage || (exports.Stage = Stage = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2luZnJhLWNvbnN0L2NvbW1vbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxvQ0FBb0M7QUFDcEMsSUFBWSxLQU9YO0FBUEQsV0FBWSxLQUFLO0lBRWIsd0JBQWUsQ0FBQTtJQUNmLG9CQUFXLENBQUE7SUFDWCxzQkFBYSxDQUFBO0lBQ2Isd0JBQWUsQ0FBQTtJQUNmLHNCQUFhLENBQUE7QUFDakIsQ0FBQyxFQVBXLEtBQUsscUJBQUwsS0FBSyxRQU9oQiIsInNvdXJjZXNDb250ZW50IjpbIi8vIEFwcGxpY2F0aW9uIGVudmlyb25tZW50IGNvbnN0YW50c1xuZXhwb3J0IGVudW0gU3RhZ2VcbntcbiAgICBMb2NhbCA9IFwibG9jYWxcIixcbiAgICBEZXYgPSBcImRldlwiLFxuICAgIEJldGEgPSBcImJldGFcIixcbiAgICBHYW1tYSA9IFwiZ2FtbWFcIixcbiAgICBQcm9kID0gXCJwcm9kXCIsXG59Il19